import Typography from '@/common/components/base/typography/Typography';
import { Flex } from 'styled-system/jsx';
import CalendarIcon from '@/common/assets/icons/calendar.svg?react';
import DocumentPrevIcon from '@/common/assets/icons/documentPrevious.svg?react';
import { token } from 'styled-system/tokens';
import { StatusTransitionHeaderType } from '@/modules/FileDetail/components/statusTransition/statusTransitionHeader/StatusTransitionHeader.type.ts';
import { css } from 'styled-system/css';

const StatusTransitionHeader = ({
  index,
  statusDate,
}: StatusTransitionHeaderType) => {
  const formattedDate = new Intl.DateTimeFormat('fa-IR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    calendar: 'persian',
  }).format(statusDate * 1000);

  return (
    <Flex px="20px" pt="10px" bg="purple-7">
      <Flex alignItems="center" justify="space-between" pb="10px" w="100%">
        <Flex align="center">
          <Typography
            textStyle="b4"
            color="black-4"
            pl="15px"
            pr="5px"
            borderLeft="1px solid {colors.gray-2}"
            ml="15px"
          >
            {index}
          </Typography>
          <DocumentPrevIcon
            stroke={token('colors.black-3')}
            className={css({ width: '12px' })}
          />
        </Flex>
        <Typography
          textStyle="b2"
          color="black-3"
          display="flex"
          alignItems="center"
          gap="5"
          className={css({ display: 'flex', alignItems: 'center' })}
        >
          {formattedDate}
          <CalendarIcon color={token('colors.black-3')} width={16} />
        </Typography>
      </Flex>
      <Flex></Flex>
    </Flex>
  );
};

export default StatusTransitionHeader;
